module.exports = __webpack_public_path__ + "img/marmol.f58481a7.jpg";